// removed by extract-text-webpack-plugin
module.exports = {"root":"_3Nk3R","pay-button":"_178H3","payButton":"_178H3","fields-group":"_37nEj","fieldsGroup":"_37nEj","field":"_1LmFj","field-left":"_1u2rh","fieldLeft":"_1u2rh","field-right":"_2AXo2","fieldRight":"_2AXo2"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/PaymentDetails/PaymentDetails.scss
// module id = 219
// module chunks = 0 1